import React, {Component} from 'react';
import LoadingComponent from "../../common/loadingComponent";
import {Redirect} from "react-router-dom";
import {getClientByID} from "../../../../services/clientService";
import {getCurrentMatchForID, getPossibleMatchesForID, saveMatch, deleteMatchFromClientID} from "../../../../services/matchUsersService";
import FicheMatchUser from "../../dataDisplay/FicheMatchUser";
import httpService from "../../../../services/httpService";
import {getCountryList} from "../../../../services/countryService";
import {getFacultyList} from "../../../../services/facultyService";
import {getInterestsList} from "../../../../services/interestsService";
import {getLanguagesList} from "../../../../services/languagesService";
import {getPreferencesList} from "../../../../services/preferencesService";
import './MatchClientPageContent.css';
import FilterMatchSelectionMenu from "../../Tables/FilterMatchSelectionMenu";
import moment from "moment";
import {getSessionsList} from "../../../../services/sessionsService";

class MatchClientPageContent extends Component {
    _isMounted = false;
    popperResizeObserver = null;

    state = {
        searchType: "suggested",
        clientID : this.props.clientID,
        matches:[],
        activeSponsorID: null,
        RedirectToLoginPage:false,
        client: {},
        tempSelectedSponsor : {},
        selectedSponsor : null,
        availabilityDate : null,
        hideFullSponsors : true,
        userIsMatched: false,
        countryList : {},
        facultyList : {},
        interestsList : {},
        studyLevelList : [{id:0, name: "Premier cycle (certificat, baccalauréat)"},{id:1, name: "Deuxième cycle (Maîtrise, DESS)"},{id:2, name: "Troisième cycle (Doctorat)"}],
        sessionsList : {},
        languagesList : {},
        preferencesList : {},
        showMatchLimit : 500,
        isLoading : true,
        isNarrowPopper: false,
        locale : this.props.locale
    };


    constructor(props) {
        super(props);
        this.state.availabilityDate = moment().format("YYYY-MM-DD")
    }


    componentDidMount() {
        this._isMounted = true;
        this.setupPopperResizeObserver();
        this.onLoadPage();
    }

    componentWillUnmount() {
        this._isMounted = false;
        this.teardownPopperResizeObserver();
    }

    setupPopperResizeObserver = () => {
        const popperContent = document.querySelector(".PopperWindow .PopperWindow-Content");
        if (!popperContent || typeof ResizeObserver === "undefined") {
            return;
        }

        const updateNarrowPopperState = () => {
            const isNarrowPopper = popperContent.clientWidth < 1000;
            if (this._isMounted && this.state.isNarrowPopper !== isNarrowPopper) {
                this.setState({isNarrowPopper});
            }
        };

        this.popperResizeObserver = new ResizeObserver(updateNarrowPopperState);
        this.popperResizeObserver.observe(popperContent);
        updateNarrowPopperState();
    }

    teardownPopperResizeObserver = () => {
        if (this.popperResizeObserver) {
            this.popperResizeObserver.disconnect();
            this.popperResizeObserver = null;
        }
    }




    onLoadPage = async () =>{
        this.setState({isLoading:true});

        try {
            this.setState({isLoading:true});
            const SPONSORS_NOT_FULLY_LOADED_STATE_VALUE = 3;

            const [
                {data: countryList},
                {data: client},
                {data: matches},
                {data: selectedSponsor},
                {data: facultyList},
                {data: interestsList},
                {data: sessionsList},
                {data: languagesList},
                {data: preferencesList}
            ] = await httpService.all([
                getCountryList('fr'),
                getClientByID(this.state.clientID),
                getPossibleMatchesForID("clients", this.state.clientID, this.state.showMatchLimit, (this.state.searchType === "suggested")?true:false, this.state.availabilityDate,SPONSORS_NOT_FULLY_LOADED_STATE_VALUE),
                getCurrentMatchForID(this.state.clientID),
                getFacultyList('fr'),
                getInterestsList('fr'),
                getSessionsList('fr'),
                getLanguagesList('fr'),
                getPreferencesList('fr')
            ]);


            if (this._isMounted){
                this.setState({
                    countryList,
                    client,
                    matches,
                    selectedSponsor,
                    tempSelectedSponsor : selectedSponsor,
                    userIsMatched : selectedSponsor?true:false,
                    facultyList,
                    interestsList,
                    sessionsList,
                    languagesList,
                    preferencesList,
                    isLoading: false
                });
            }

        }  catch(err)  {
            console.log("Error loading API")
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }

    handleSelectMatchFile = (sponsor) => {
        this.setState({tempSelectedSponsor: sponsor})
    }

    handleToggleMatchDetails = (sponsor, event) => {
        if (event) {
            event.stopPropagation();
        }

        this.setState((prevState) => ({
            activeSponsorID: prevState.activeSponsorID === sponsor.id ? null : sponsor.id
        }))
    }

    handleHideFullSponsors = (e) => {
        this.setState({hideFullSponsors : e.currentTarget.checked})
    }

    handleResultsLimitChange = (e) => {
        this.setState({showMatchLimit : e.currentTarget.value})
        console.log("New result limit : " + e.currentTarget.value)
    }

    handleSearchTypeChange = (e) => {
        this.setState({searchType : e.currentTarget.value})
        console.log("New search type : " + e.currentTarget.value)
    }

    handleAvailabilityDateChange = (e) => {
        this.setState({availabilityDate : e.currentTarget.value})
    }

    handleLaunchSearch = async () => {
        try {
            this.setState({isLoading:true});
            // const {data : matches} = await getPossibleMatchesForID("clients",
            //                                                 this.state.clientID,
            //                                                 this.state.showMatchLimit,
            //                                             (this.state.searchType === "suggested")?true:false,
            //                                                 this.state.availabilityDate,
            //                                                 this.state.hideFullSponsors);
            let {data: matches} = await getPossibleMatchesForID("clients", this.state.clientID, this.state.showMatchLimit, (this.state.searchType === "suggested")?true:false, this.state.availabilityDate, this.state.hideFullSponsors?3:0);
            this.setState({
                matches,
                isLoading: false}
                )
        }
        catch(err) {
            console.log("Error loading API")
            if (this._isMounted) {
                this.setState({isLoading: false, RedirectToLoginPage: true});
            }
        }
    }

    updateMatchUser = (deleting) => {
        const updatedUsers = this.props.usersList.map((user) => {
            if (user.id === this.state.clientID) {
                if(!deleting)
                {
                    return { ...user, takenInChargeByID: this.state.selectedSponsor.id, takenInChargeByName: this.state.selectedSponsor.firstName + " " + this.state.selectedSponsor.lastName};
                }
                return { ...user, takenInChargeByID: null, takenInChargeByName: null };
            }
            return user;
        });
        this.props.setUsersList(updatedUsers);
    }



    handleSaveMatch = async () => {
        //console.log("Saving Match: " + this.state.clientID + " with " + this.state.tempSelectedSponsor.id)
        const matchObject = {
            clientID: this.state.clientID,
            sponsorID: this.state.tempSelectedSponsor.id
        }

            try{
            // console.log(this.props.usersList);»
                this.setState({isLoading:true});
                await saveMatch(matchObject);
                this.setState({userIsMatched : true})
                const {data:currentMatch} = await getCurrentMatchForID(this.state.clientID);
                this.setState({selectedSponsor : currentMatch})
                await this.handleLaunchSearch();
                this.setState({isLoading:false});
                if(this.props.setMatchClientWindowState){
                    this.updateMatchUser(false);
                }
                this.props.setMatchClientWindowState(false);
            } catch (e){
                this.setState({isLoading:false});
            }

    }

    handleDeleteMatch = async () => {
        const confirmDelete = window.confirm("Voulez-vous vraiment supprimer ce jumelage ?");
        if (!confirmDelete) return;

        try{
            this.setState({isLoading:true});
            await deleteMatchFromClientID(this.state.clientID);
            this.props.deleteMatchInUserListState(this.state.clientID);
            this.setState({userIsMatched:false});
            this.setState({selectedSponsor:null});
            this.setState({tempSelectedSponsor:{}});
            await this.handleLaunchSearch();
            this.setState({isLoading:false});
            if(this.props.setMatchClientWindowState){
                this.updateMatchUser(true);
            }
            this.props.setMatchClientWindowState(false);
        }catch(err){
            this.setState({isLoading:false});
        }
    }


    renderPage = () => {
        const userMatches = this.state.matches.length?this.state.matches: {};
        const userMatchesLength = Object.keys(userMatches).length;
        const maxedOut = userMatchesLength === this.state.showMatchLimit;
        const currentClient = this.state.client;
        const selectedSponsorID = Number(this.state.selectedSponsor?.id);
        const tempSponsorID = Number(this.state.tempSelectedSponsor?.id);

        if (userMatches != null){
            return(
                <>

                    <FilterMatchSelectionMenu
                        selectedSponsor = {this.state.selectedSponsor}
                        resultsLimit = {this.state.showMatchLimit}
                        searchType = {this.state.searchType}
                        availabilityDate = {this.state.availabilityDate}
                        hideFullSponsors = {this.state.hideFullSponsors}
                        onResultsLimitChange = {this.handleResultsLimitChange}
                        onSearchTypeChange = {this.handleSearchTypeChange}
                        onHideFullSponsors = {this.handleHideFullSponsors}
                        onLaunchSearch = {this.handleLaunchSearch}
                        onAvailabilityDateChange = {this.handleAvailabilityDateChange}
                        facultyList = {this.state.facultyList}
                        countryList = {this.state.countryList}
                        languageList = {this.state.languagesList}
                        preferencesList = {this.state.preferencesList}
                        interestsList = {this.state.interestsList}
                        sessionsList = {this.state.sessionsList}
                        studyLevelList = {this.state.studyLevelList}
                        matchesList = {this.state.matches}
                    />



                    <div className="container matchClientWorkspace">
                        <div className="searchMatchFooter">
                            Affichage de {Object.keys(userMatches).length} éléments. {maxedOut?<div style={{color: "red"}}>ATTENTION ! Il est possible d'obtenir plus de résultat en augmentant la limite de résultats de recherche!</div>:<span></span>}
                        </div>

                        <div className="row matchWorkspaceRow">
                            <div className="col-md-6 studentColumn">
                                <div className="matchStudentSticky">
                                    <div className="matchColumnTitle">Etudiant a jumeler</div>
                                    <div className="matchActionsBar">
                                        <button
                                            onClick={this.handleSaveMatch}
                                            disabled={!this.state.tempSelectedSponsor?.id}
                                            className="btn btn-primary saveMatchButton"
                                        >
                                            Sauvegarder le jumelage
                                        </button>

                                        <button
                                            onClick={this.handleDeleteMatch}
                                            disabled={this.state.userIsMatched?false:true}
                                            className="btn btn-danger saveMatchButton"
                                        >
                                            Supprimer le jumelage
                                        </button>
                                    </div>

                                    <FicheMatchUser
                                        affix={true}
                                        data={currentClient}
                                        facultyList={this.state.facultyList}
                                        countryList={this.state.countryList}
                                        languageList={this.state.languagesList}
                                        preferencesList={this.state.preferencesList}
                                        interestsList={this.state.interestsList}
                                        sessionsList={this.state.sessionsList}
                                        studyLevelList={this.state.studyLevelList}
                                        compact={true}
                                    />

                                </div>

                            </div>

                            <div className="col-md-6 sponsorColumn">
                                <div className="matchColumnTitle">Parrains et marraines disponibles</div>
                                <div className="sponsorAccordionList">
                                    {
                                        userMatches.length &&
                                        userMatches.map((value, key) => {
                                            const isOpen = this.state.activeSponsorID === value.id;
                                            const sponsorAge = moment().diff(value.birthdate, "years");
                                            const sponsorGender = value.gender === 1 ? "Homme" : (value.gender === 0 ? "Femme" : "Non precise");
                                            const sponsorVeteranStatus = value.isVeteran === 1 ? "Veteran" : "Nouveau";
                                            const sponsorAvailability = value.availabilityDate ? moment(value.availabilityDate).format("YYYY/MM/DD") : "Inconnue";
                                            const sponsorSession = this.state.sessionsList.find((session) => session.id === value.firstSession_id)?.name || "Inconnue";
                                            const sponsorCountry = this.state.countryList.find((country) => country.id === value.originCountry_id)?.name || "Inconnu";
                                            const sponsorPrimaryLang = this.state.languagesList.find((lang) => lang.id === value.languagePrimary_id)?.name || "Inconnue";
                                            const sponsorStudyCycle = this.state.studyLevelList.find((lvl) => lvl.id === value.studyLevel)?.name || "Inconnu";
                                            const sponsorCurrentLoad = value.inChargeOfClientsID?.length ?? value.sponsorLoadCurrent ?? 0;
                                            const sponsorMaxLoad = value.sponsorLoad ?? 0;
                                            const sponsorIsFull = sponsorMaxLoad > 0 && sponsorCurrentLoad >= sponsorMaxLoad;
                                            const availabilityMoment = value.availabilityDate ? moment(value.availabilityDate) : null;
                                            let availabilityClass = "unknown";
                                            if (availabilityMoment && availabilityMoment.isValid()) {
                                                if (availabilityMoment.isSame(moment(), "day")) availabilityClass = "today";
                                                else if (availabilityMoment.isBefore(moment(), "day")) availabilityClass = "past";
                                                else availabilityClass = "future";
                                            }
                                            const veteranClass = value.isVeteran === 1 ? "veteran" : "newcomer";

                                            return (
                                                <article
                                                    key={key}
                                                    className={`sponsorAccordionItem ${isOpen ? "open" : ""} ${tempSponsorID === Number(value.id) ? "tempSelected" : ""} ${selectedSponsorID === Number(value.id) ? "currentSelectedMatch" : ""}`}
                                                >
                                                    <div className={`sponsorAccordionTrigger ${this.state.isNarrowPopper ? "narrowPopper" : ""}`} onClick={() => this.handleSelectMatchFile(value)}>
                                                        <span className="sponsorIdentity">
                                                            <span className="sponsorName">{value.firstName} {value.lastName} ({Number.isNaN(sponsorAge) ? "-" : sponsorAge} ans)</span>
                                                            <span className="sponsorFaculty">{this.state.facultyList.find((fac) => fac.id === value.faculty_id)?.name || "Faculte inconnue"}</span>

                                                            <span className="sponsorMetaRow">
                                                                <span className="matchScoreBadge">Score: {value.matchAttributes?.score ?? 0}</span>
                                                                <span className={`sponsorLoadBadge ${sponsorIsFull ? "overLimit" : ""}`}>Charge: {sponsorCurrentLoad}/{sponsorMaxLoad}</span>
                                                                {sponsorIsFull && <span className="sponsorLoadFullBadge">Complet</span>}
                                                                <span className={`sponsorMetaItem availability ${availabilityClass}`}>Dispo: {sponsorAvailability}</span>
                                                                <span className={`sponsorMetaItem status ${veteranClass}`}>Statut: {sponsorVeteranStatus}</span>
                                                                <span className="sponsorMetaItem neutral">Sexe: {sponsorGender}</span>
                                                            </span>

                                                            {!isOpen &&
                                                            <span className="sponsorMetaInlineRow">
                                                                <span className="sponsorMetaInline">Session: {sponsorSession}</span>
                                                                <span className="sponsorMetaInline">Pays: {sponsorCountry}</span>
                                                                <span className="sponsorMetaInline">Langue maternelle: {sponsorPrimaryLang}</span>
                                                                <span className="sponsorMetaInline">Cycle: {sponsorStudyCycle}</span>
                                                            </span>
                                                            }
                                                        </span>

                                                        <span className="sponsorQuickStats">
                                                        </span>

                                                        <button
                                                            type="button"
                                                            className="sponsorAccordionCta"
                                                            onClick={(event) => this.handleToggleMatchDetails(value, event)}
                                                            aria-expanded={isOpen}
                                                        >
                                                            {isOpen ? "Masquer" : "Details"}
                                                        </button>
                                                    </div>

                                                    {isOpen &&
                                                    <div className="sponsorAccordionPanel">
                                                        <FicheMatchUser
                                                            selectedID={this.state.tempSelectedSponsor.id}
                                                            data={value}
                                                            facultyList={this.state.facultyList}
                                                            countryList={this.state.countryList}
                                                            languageList={this.state.languagesList}
                                                            preferencesList={this.state.preferencesList}
                                                            interestsList={this.state.interestsList}
                                                            sessionsList={this.state.sessionsList}
                                                            studyLevelList={this.state.studyLevelList}
                                                            compact={true}
                                                        />
                                                    </div>
                                                    }
                                                </article>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return(
                <>
                    Aucun match disponible.
                </>
                )

        }

    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.isLoading ? <LoadingComponent/> : this.renderPage()}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default MatchClientPageContent;